import React from 'react'
import styled from 'styled-components'
import IEventedComponent from './IEventedComponent'

const TitleContainer = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: start;
`

const TitleText = styled.div`
  margin-right: 17px;
  font-weight: 400;
  font-size: 18px;
`

interface IProps {
  title: string
  titleFontSizePx?: string
  children?: any
}

const SectionTitle = class extends IEventedComponent<IProps, {}> {
  render() {
    const { title, titleFontSizePx, children } = this.props
    return (
      <TitleContainer>
        <TitleText style={titleFontSizePx ? { fontSize: titleFontSizePx + 'px' } : {}}>{title}</TitleText>
        {children}
      </TitleContainer>
    )
  }
}

export default SectionTitle
